import React from 'react';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from './loading';
import {
  Radar, RadarChart, PolarGrid, 
  PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer,
  Legend
} from 'recharts';
import { calcCafeteriaMenu, calcNutrition, CON_TARGET_DATA } from '../helper';
import * as dateFns from 'date-fns';

export default class CalcResult extends React.Component {
    constructor(props) {
        super(props);
    }

    handleSelectMenuChange = (id, selected) => {
        this.props.onSelectMenuChange(id, selected);
    }

    handleOneServingChange = (new_value) => {
        this.props.onOneServingChange(new_value);
    }

    storeLocalStorage = () => {
        const storage = JSON.parse(localStorage.getItem('calc_histories')) || [];
        const now = new Date();
        const key = dateFns.format(now, 'yyyyMMddHHmmss');
        const menu = [];
        for (const m of this.props.select_cafeteria_menu) {
            menu.push({
                menu_name: m.acf.menu_name,
                calories: m.acf.calories,
                protein: m.acf.protein,
                lipid: m.acf.lipid,
                carbohydrate: m.acf.carbohydrate,
                sodium_content: m.acf.sodium_content,
                potassium: m.acf.potassium,
                dietary_fiber: m.acf.dietary_fiber,
                iron: m.acf.iron,
                img_url: m.img_urls.medium,
            });
        }
        storage.push({
            key: key,
            label: this.props.provide_name + ' ' + dateFns.format(now, 'yyyy/M/d H:mm:ss') + '保存',
            user_attributes: this.props.user_attributes,
            menu: menu,
        });
        storage.sort((a, b) => b.key.localeCompare(a.key, 'ja'));
        try {
            localStorage.setItem('calc_histories', JSON.stringify(storage));
            this.props.onToastShow('保存しました。');
        } catch (e) {
            alert('保存に失敗しました。保存履歴が大量にある、又はブラウザでCookieやストレージをブロックしている可能性があります。');
        }
    }

    render() {
        const menu = [];
        if (this.props.cafeteria_menu.length > 0) {
            for (const m of this.props.cafeteria_menu) {
                const selected = this.props.select_cafeteria_menu.filter(item => item.id === m.id).length > 0;
                menu.push(
                    <React.Fragment>
                        <div className={selected ? 'check-select select-block-1' : 'no-check-select select-block-1'} onClick={() => this.handleSelectMenuChange(m.id, selected ? false : true)}>
                            <div className="select-block-1-1">
                                {
                                    selected &&
                                    <div className="select-block-1-1-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                                }
                                {
                                    !selected &&
                                    <div className="select-block-1-1-1"><FontAwesomeIcon icon={faSquare} /></div>
                                }
                                <div className="select-block-1-1-2">
                                    {m.acf.menu_name}<br/>
                                    <span className="menu-info">エネルギー:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.calories))}kcal</span>
                                    <span className="menu-info">たんぱく質:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.protein * 10) / 10)}g</span>
                                    <span className="menu-info">脂質:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.lipid * 10) / 10)}g</span>
                                    <span className="menu-info">炭水化物:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.carbohydrate * 10) / 10)}g</span>
                                    <span className="menu-info">食塩相当量:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.sodium_content * 10) / 10)}g</span>
                                    <span className="menu-info">カリウム:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.potassium))}mg</span>
                                    <span className="menu-info">食物繊維:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.dietary_fiber * 10) / 10)}g</span>
                                    <span className="menu-info">鉄:{Intl.NumberFormat('ja-JP').format(Math.round(m.acf.iron * 10) / 10)}mg</span>
                                </div>
                            </div>
                            <div className="select-block-1-2">
                                <img
                                    className="select-menu-img"
                                    src={m.img_urls.medium}
                                    onError={(e) => {e.target.src = window.cafeteria_path.template_url + '/img/no_image.svg'}}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
            }
        }
        const graph_data = calcCafeteriaMenu(this.props.user_attributes.sex, this.props.user_attributes.age, this.props.user_attributes.life_activity_intensity, this.props.is_one_serving, this.props.select_cafeteria_menu);
        const calc_data = calcNutrition(this.props.user_attributes.sex, this.props.user_attributes.age, this.props.user_attributes.life_activity_intensity, this.props.is_one_serving, this.props.select_cafeteria_menu);
        return (
            <div className={`calc-result-flex ${this.props.className ?? ''}`}>
                <h1 className="bb-1px-solid">メニュー選択</h1>
                <div className="select-group">
                    {
                        menu.length == 0 &&
                        <Loading />
                    }
                    {
                        menu.length > 0 &&
                        menu
                    }
                </div>
                <h1 className="bb-1px-solid">摂取基準選択</h1>
                <div className="select-group">
                    <div className={this.props.is_one_serving ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleOneServingChange(true)}>
                        {
                            this.props.is_one_serving &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            !this.props.is_one_serving &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">１食あたり</div>
                    </div>
                    <div className={!this.props.is_one_serving ? 'check-select select-block-2' : 'no-check-select select-block-2'} onClick={() => this.handleOneServingChange(false)}>
                        {
                            !this.props.is_one_serving &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            this.props.is_one_serving &&
                            <div className="select-block-2-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-2-2">１日あたり</div>
                    </div>
                </div>
                <h1 className="bb-1px-solid">グラフ</h1>
                <div className="graph-group">
                    <ResponsiveContainer>
                        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={graph_data}>
                            {/* 網目の設定 */}
                            <PolarGrid stroke="#A9BCC6" />
                            {/* 項目名（ラベル）の設定 */}
                            <PolarAngleAxis dataKey="subject" tick={{ fill: '#4A4A4A', fontSize: '0.7rem' }} />
                            {/* 目盛りの設定（隠すことも可能） */}
                            <PolarRadiusAxis angle={30} tick={false} axisLine={false} />
                            {/* レーダー本体 */}
                            <Radar
                                name="目安値"
                                dataKey="target"
                                stroke="#a5cadd"
                                fill="#a5cadd"
                                fillOpacity={0.6}
                                animationDuration={300}
                            />
                            <Radar
                                name="選択メニュー"
                                dataKey="select"
                                stroke="#48b344"
                                fill="#48b344"
                                fillOpacity={0.8}
                                animationDuration={300}
                            />
                            <Legend
                                wrapperStyle={{paddingTop: '1.5rem'}}
                                formatter={(value) => <span style={{color: '#404040', fontSize: '0.8rem'}}>{value}</span>}
                            />
                        </RadarChart>
                    </ResponsiveContainer>
                </div>
                <h1 className="bb-1px-solid">合計栄養価</h1>
                <table className="table-group">
                    <thead>
                        <tr>
                            <th scope="col">栄養素</th>
                            <th scope="col">目安／目標／推奨量</th>
                            <th scope="col">計算値</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">エネルギー</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.calories))}&nbsp;kcal</td>
                            <td className={calc_data.cell.calories}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.calories))}&nbsp;kcal</td>
                        </tr>
                        <tr>
                            <th scope="row">たんぱく質</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.protein))}&nbsp;g</td>
                            <td className={calc_data.cell.protein}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.protein))}&nbsp;g</td>
                        </tr>
                        <tr>
                            <th scope="row">脂質</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.lipid[0] * 10) / 10)}&nbsp;g&nbsp;～&nbsp;{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.lipid[1] * 10) / 10)}&nbsp;g</td>
                            <td className={calc_data.cell.lipid}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.lipid * 10) / 10)}&nbsp;g</td>
                        </tr>
                        <tr>
                            <th scope="row">炭水化物</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.carbohydrate * 10) / 10)}&nbsp;g</td>
                            <td className={calc_data.cell.carbohydrate}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.carbohydrate * 10) / 10)}&nbsp;g</td>
                        </tr>
                        <tr>
                            <th scope="row">食塩相当量</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.sodium_content * 10) / 10)}&nbsp;g</td>
                            <td className={calc_data.cell.sodium_content}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.sodium_content * 10) / 10)}&nbsp;g</td>
                        </tr>
                        <tr>
                            <th scope="row">カリウム</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.potassium))}&nbsp;mg</td>
                            <td className={calc_data.cell.potassium}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.potassium))}&nbsp;mg</td>
                        </tr>
                        <tr>
                            <th scope="row">食物繊維</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.dietary_fiber * 10) / 10)}&nbsp;g</td>
                            <td className={calc_data.cell.dietary_fiber}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.dietary_fiber * 10) / 10)}&nbsp;g</td>
                        </tr>
                        <tr>
                            <th scope="row">鉄</th>
                            <td>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.target.iron * 10) / 10)}&nbsp;mg</td>
                            <td className={calc_data.cell.iron}>{Intl.NumberFormat('ja-JP').format(Math.round(calc_data.select.iron * 10) / 10)}&nbsp;mg</td>
                        </tr>
                    </tbody>
                </table>
                <div className="info-group">
                    <p>※ 食事摂取基準値は「日本人の食事摂取基準（2025年版）を参照しています。</p>
                    <p>※ 食材の産地や調理方法により実際の栄養価とは異なる場合があります。</p>
                    <p>※ 結果はあくまで目安です。個人の体質、体調、活動量、疾患の有無によって最適な摂取量は異なります。</p>
                </div>
                <button className="store-button" disabled={this.props.select_cafeteria_menu.length < 1} onClick={() => this.storeLocalStorage()}>計算結果を保存</button>
                <div className="info-group">
                    <p>※ 保存したデータは端末及びブラウザ毎に保存されます。<br/>保存した環境以外では計算結果が取得できないことがあります。</p>
                    <p>※ 大量に保存した場合やブラウザ設定にてCookie／ローカルストレージの利用を制限している場合、保存できないことがあります。</p>
                </div>
            </div>
        );
    }
}